import React from 'react';

const PrivacyPolicy = () => {
  const styles = {
    page: { background: '#f8fafc', minHeight: '100vh', padding: '48px 20px', fontFamily: '"Inter", Arial, sans-serif' },
    card: { maxWidth: '820px', margin: '0 auto', background: '#ffffff', borderRadius: '16px', padding: '48px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', color: '#1e293b', lineHeight: '1.7' },
    h1: { fontSize: '32px', fontWeight: '800', marginBottom: '8px', color: '#0f172a' },
    meta: { color: '#64748b', fontSize: '14px', marginBottom: '32px', paddingBottom: '24px', borderBottom: '1px solid #e2e8f0' },
    h2: { fontSize: '20px', fontWeight: '700', marginTop: '36px', marginBottom: '12px', color: '#0f172a' },
    ul: { paddingLeft: '22px', margin: '12px 0' },
    li: { marginBottom: '8px' },
    callout: { background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px 24px', marginTop: '12px' },
    link: { color: '#059669', fontWeight: '600', textDecoration: 'none' },
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Privacy Policy</h1>
        <div style={styles.meta}>
          <strong>Tesla CRM Connect</strong>, a product of Tesla Online Solution<br />
          Effective date: 14 July 2026
        </div>

        <h2 style={styles.h2}>1. Introduction</h2>
        <p>
          Tesla CRM Connect is a customer relationship and messaging platform operated by Tesla Online Solution.
          It allows businesses to manage conversations with their customers over WhatsApp. This policy explains what
          information we collect, how we use it, who we share it with, and how you can have it deleted.
        </p>

        <h2 style={styles.h2}>2. Information We Collect</h2>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <strong>Account information.</strong> The name, email address, and business details you provide when you
            register for an account.
          </li>
          <li style={styles.li}>
            <strong>WhatsApp Business account information.</strong> When you connect your WhatsApp Business account,
            we receive your WhatsApp Business Account ID, phone number ID, display phone number, and the access token
            that permits us to send and receive messages on your behalf.
          </li>
          <li style={styles.li}>
            <strong>Phone numbers.</strong> The phone numbers of the customers who contact your business, and of the
            contacts you upload or add to the platform.
          </li>
          <li style={styles.li}>
            <strong>Message data.</strong> The content, timestamps, and delivery status of messages sent and received
            between your business and your customers through the platform.
          </li>
        </ul>

        <h2 style={styles.h2}>3. How We Use Your Information</h2>
        <p>We use this information solely to operate the service. Specifically, to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Deliver messages between your business and your customers.</li>
          <li style={styles.li}>Display your conversations, contacts, and message history in your dashboard.</li>
          <li style={styles.li}>Provide CRM features such as contact management, templates, broadcasts, and automated replies.</li>
          <li style={styles.li}>Maintain, secure, troubleshoot, and improve the platform.</li>
        </ul>
        <p>
          We <strong>do not</strong> sell your data. We <strong>do not</strong> use WhatsApp message data for advertising,
          and we do not share it with advertisers or data brokers.
        </p>

        <h2 style={styles.h2}>4. Meta&rsquo;s WhatsApp Business Platform</h2>
        <p>
          Tesla CRM Connect is built on Meta&rsquo;s WhatsApp Business Platform. Messages you send and receive through the
          platform are transmitted through Meta&rsquo;s infrastructure, and your use of WhatsApp messaging is also governed by
          Meta&rsquo;s own terms and privacy policy. We share data with Meta only to the extent required to deliver your
          messages and to maintain your WhatsApp Business account connection.
        </p>

        <h2 style={styles.h2}>5. Data Sharing</h2>
        <p>
          Beyond Meta, we share your information only with the infrastructure providers required to run the service
          (such as our cloud hosting and database provider), and where we are legally required to do so. We do not share
          your information with any other third parties.
        </p>

        <h2 style={styles.h2}>6. Data Retention and Deletion</h2>
        <p>
          We retain your data for as long as your account remains active and we need it to provide the service. You may
          request deletion of your account data, or of your customers&rsquo; data, at any time.
        </p>
        <div style={styles.callout}>
          <strong>To request data deletion:</strong> email{' '}
          <a href="mailto:teslaonlinesolution@gmail.com" style={styles.link}>teslaonlinesolution@gmail.com</a>{' '}
          from the email address associated with your account, stating what you want deleted. We will action the request
          and confirm once your data has been removed from our systems.
        </div>

        <h2 style={styles.h2}>7. Security</h2>
        <p>
          Access tokens and message data are stored in access-controlled cloud infrastructure, and data in transit is
          encrypted. No system is perfectly secure, but we take reasonable measures to protect your information from
          unauthorised access.
        </p>

        <h2 style={styles.h2}>8. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time. Any changes will be posted on this page with a revised effective
          date.
        </p>

        <h2 style={styles.h2}>9. Contact Us</h2>
        <p>
          If you have questions about this policy or about how your data is handled, contact us at:
        </p>
        <div style={styles.callout}>
          <strong>Tesla Online Solution</strong><br />
          Email: <a href="mailto:teslaonlinesolution@gmail.com" style={styles.link}>teslaonlinesolution@gmail.com</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
